import { Link } from "react-router-dom";
import { T } from "../constants/theme";

export default function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "80px 24px",
        background: T.paper,
      }}
    >
      <div style={{ fontSize: 72, fontWeight: 900, color: T.ink, letterSpacing: "-.02em" }}>
        404
      </div>
      <h1
        style={{
          fontFamily: "'Crimson Text', Georgia, serif",
          fontSize: 28,
          color: T.ink,
          margin: "12px 0",
        }}
      >
        Page Not Found
      </h1>
      <p style={{ color: T.muted, maxWidth: 420, lineHeight: 1.7, marginBottom: 28 }}>
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/shop"
        style={{
          display: "inline-block",
          background: T.ink,
          color: "#fff",
          borderRadius: 999,
          padding: "12px 28px",
          fontWeight: 700,
          fontSize: 13,
          letterSpacing: ".08em",
          textTransform: "uppercase",
          textDecoration: "none",
        }}
      >
        Back to Shop
      </Link>
    </div>
  );
}
